/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Bannerdetails3Inputs */

const en_coinvestments_declinedeal_bannerdetails3 = /** @type {(inputs: Coinvestments_Declinedeal_Bannerdetails3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This opportunity is no longer active and no further notifications will be sent.`)
};

/**
* | output |
* | --- |
* | "This opportunity is no longer active and no further notifications will be sent." |
*
* @param {Coinvestments_Declinedeal_Bannerdetails3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_bannerdetails3 = /** @type {((inputs?: Coinvestments_Declinedeal_Bannerdetails3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Bannerdetails3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_bannerdetails3(inputs)
});
export { coinvestments_declinedeal_bannerdetails3 as "coInvestments_declineDeal_bannerDetails" }